import { useCallback, useState } from 'react';
import { useAppContext } from '../../appprovider';
import { canWrite } from '../services/demoPolicy';

/**
 * Shared demo write-gating for page-level and row-level actions.
 * Returns lock state, a guard helper, and props for locked menu items.
 */
export default function useDemoActionGate() {
  const { entitlements } = useAppContext();
  const [lockedDialogOpen, setLockedDialogOpen] = useState(false);

  const isLocked = useCallback(
    (featureKey) => !canWrite(entitlements, featureKey),
    [entitlements],
  );

  const showLockedDialog = useCallback(() => setLockedDialogOpen(true), []);

  const guardAction = useCallback(
    (featureKey, action) => {
      if (isLocked(featureKey)) {
        setLockedDialogOpen(true);
        return false;
      }
      if (action) action();
      return true;
    },
    [isLocked],
  );

  const lockProps = useCallback(
    (featureKey, onBlockedClick) => ({
      locked: isLocked(featureKey),
      onBlockedClick: onBlockedClick || showLockedDialog,
    }),
    [isLocked, showLockedDialog],
  );

  return {
    isLocked,
    guardAction,
    lockProps,
    lockedDialogOpen,
    setLockedDialogOpen,
  };
}
